import { render, staticRenderFns } from "./AfterAuth.vue?vue&type=template&id=30c4cc90&"
import script from "./AfterAuth.vue?vue&type=script&lang=js&"
export * from "./AfterAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports